import { RouteProps } from "react-router";
import { RouteMeta } from "../../SecureRoutes";

export type SecureRouteProps = RouteProps & Partial<RouteMeta>;

export const SecureRoute = (props: SecureRouteProps) => {
  return null;
};
